import React, { useEffect, useState } from "react";
import { Col, Modal, Row, Form } from "react-bootstrap";
// import { Form } from 'react-router-dom';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import Flatpickr from "react-flatpickr";
import moment from "moment";

const EditExperienceAchivement = ({
  getUserCv,
  userDataId,
  handleCloseEditExperienceAchivement,
  showEditExperienceAchivement,
  experienceData,
  experienceAchivementData,
}) => {
  console.log("experienceAchivementData", experienceAchivementData);
  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
  const { CandidateId } = useParams();
  const [achievement, setAchievement] = useState("");
  const [achievementtDate, setAchievementDate] = useState("");
  const [display, setDisplay] = useState(false);
  console.log("CandidateId", CandidateId);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisplay(true);
    const body = {
      sessionId: sessionId,
      userDataId: userDataId,
      userType: userType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
      expId: experienceData.usrDataExpId,
      expAchvmntId: experienceAchivementData.usrDataExpAchvmntId,
      achievement: achievement,
      achivementDate: moment(achievementtDate).format("YYYY-MM-DD"),
    };
    console.log("body", body);
    if (achievement === "" || achievementtDate === "") {
      toast.error("Please fill all the required fields");
    } else {
      try {
        const res = await axios.post(
          "/Resume/UpdateExperienceAchievement",
          body
        );
        toast.success(res.data.message);
        handleCloseEditExperienceAchivement();
        getUserCv();
        setDisplay(false);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.warning(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message || "An error occurred");
        }
      }
    }
  };

  useEffect(() => {
    if (experienceAchivementData) {
      setAchievement(experienceAchivementData.achievement);
      setAchievementDate(experienceAchivementData.achivementDate);
    }
  }, [experienceAchivementData]);

  return (
    <Modal
      show={showEditExperienceAchivement}
      onHide={handleCloseEditExperienceAchivement}
      centered
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>Edit Experience Achivement</Modal.Title>
        <CloseSharpIcon
          className="pointer"
          onClick={handleCloseEditExperienceAchivement}
        />
      </Modal.Header>
      <Modal.Body className="settings">
        <Row>
          <Col md={12}>
            <Form.Group controlId="grade">
              <Form.Label className="class-type">
                Achivement{" "}
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </Form.Label>
              <Form.Control
                type="text"
                className=" Dark-Input-from-group"
                value={achievement}
                onChange={(e) => setAchievement(e.target.value)}
                placeholder="Enter Achivement"
              />
              {display && !achievement ? (
                <span className="error_msg_lbl">Add Achievement </span>
              ) : null}
            </Form.Group>
          </Col>
          <Col md={12} className="mb-2">
            <Form.Group controlId="endYear">
              <Form.Label className="class-type">
                Achivement Date{" "}
                <span style={{ color: "red" }} className="ms-2">
                  *
                </span>
              </Form.Label>
              <Flatpickr
                type="number"
                value={achievementtDate}
                onChange={(date) => setAchievementDate(date[0])}
                placeholder="Enter Achievement Date"
                // disabled={isPresent}
              />
              {display && !achievementtDate ? (
                <span className="error_msg_lbl">Select Achievement Date </span>
              ) : null}
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-4">
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3">
              <a href="#/" onClick={handleSubmit}>
                Submit
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditExperienceAchivement;
